import { ComentarioOcorrencia } from './comentario-ocorrencia';
import { Construtor } from './construtor';
import { StatusOcorrencia } from './status-ocorrencia';
import { TipoOcorrencia } from './tipo-ocorrencia';
import { TransicaoOcorrencia } from './transicao-ocorrencia';
import { PontoFisico } from './ponto-fisico';

export class Ocorrencia implements Construtor<Ocorrencia> {

  public idOcorrencia: number;
  public dataAbertura: Date;
  public dataAberturaString: string;
  public tipoOcorrencia: TipoOcorrencia;
  public descricaoOcorrencia: string;
  public statusOcorrencia: StatusOcorrencia;
  public prazoSolucao: number;
  public idCliente: number;
  public idUsuario: number;
  public imagem: string;
  public pontoFisico: PontoFisico;
  public idSetorPontoFisico: number;
  public idProcessoSetor: number;
  public idRotinaProcesso: number;
  public idCriterioAvaliacaoRotinaCliente: number;
  public dataEncerramento: Date;
  public comentariosOcorrencia: ComentarioOcorrencia[];
  public transicoesOcorrencia: TransicaoOcorrencia[];

  constructor(object?: any) {
    this.tipoOcorrencia = new TipoOcorrencia();
    this.statusOcorrencia = new StatusOcorrencia();
    this.pontoFisico = new PontoFisico();
    this.comentariosOcorrencia = new Array<ComentarioOcorrencia>();
    this.transicoesOcorrencia = new Array<TransicaoOcorrencia>();
    if (object !== undefined) {
      if (object instanceof (Ocorrencia)) {
        this.copyObject(object);
      } else if (object instanceof TipoOcorrencia) {
        this.tipoOcorrencia = new TipoOcorrencia(object);
      } else if (object instanceof StatusOcorrencia) {
        this.statusOcorrencia = new StatusOcorrencia(object);
      } else if (object instanceof PontoFisico) {
        this.pontoFisico = new PontoFisico(object);
      } else {
        this.parseFromJson(object);
      }

      if (!this.modeloCompleto()) {
        return null;
      }
    }
  }

  set IdOcorrencia(idOcorrencia: any) {
    this.idOcorrencia = idOcorrencia;
  }

  set DataAbertura(dataAbertura: any) {
    this.dataAbertura = dataAbertura;
  }

  set TipoOcorrencia(tipoOcorrencia: any) {
    this.tipoOcorrencia = tipoOcorrencia;
  }

  set DescricaoOcorrencia(descricaoOcorrencia: any) {
    this.descricaoOcorrencia = descricaoOcorrencia;
  }

  set StatusOcorrencia(statusOcorrencia: any) {
    this.statusOcorrencia = statusOcorrencia;
  }

  set PrazoSolucao(prazoSolucao: any) {
    this.prazoSolucao = prazoSolucao;
  }

  set IdCliente(idCliente: any) {
    this.idCliente = idCliente;
  }

  set IdUsuario(idUsuario: any) {
    this.idUsuario = idUsuario;
  }

  set Imagem(imagem: any) {
    this.imagem = imagem;
  }

  set PontoFisico(pontoFisico: any) {
    this.pontoFisico = pontoFisico;
  }

  set IdSetorPontoFisico(idSetorPontoFisico: any) {
    this.idSetorPontoFisico = idSetorPontoFisico;
  }

  set IdProcessoSetor(idProcessoSetor: any) {
    this.idProcessoSetor = idProcessoSetor;
  }

  set IdRotinaProcesso(idRotinaProcesso: any) {
    this.idRotinaProcesso = idRotinaProcesso;
  }

  set IdCriterioAvaliacaoRotinaCliente(idCriterioAvaliacaoRotinaCliente: any) {
    this.idCriterioAvaliacaoRotinaCliente = idCriterioAvaliacaoRotinaCliente;
  }

  set DataEncerramento(dataEncerramento: any) {
    this.dataEncerramento = dataEncerramento;
  }

  set ComentariosOcorrencia(comentariosOcorrencia: any) {
    this.comentariosOcorrencia = comentariosOcorrencia;
  }

  set TransicoesOcorrencia(transicoesOcorrencia: any) {
    this.transicoesOcorrencia = transicoesOcorrencia;
  }

  parseFromJson(ocorrencia: any): void {
    this.IdOcorrencia = ocorrencia.idOcorrencia;
    this.DataAbertura = ocorrencia.dataAbertura;
    this.dataAberturaString = ocorrencia.dataAberturaString;
    this.TipoOcorrencia = ocorrencia.tipoOcorrencia;
    this.DescricaoOcorrencia = ocorrencia.descricaoOcorrencia;
    this.StatusOcorrencia = ocorrencia.statusOcorrencia;
    this.PrazoSolucao = ocorrencia.prazoSolucao;
    this.IdCliente = ocorrencia.idCliente;
    this.IdUsuario = ocorrencia.idUsuario;
    this.Imagem = ocorrencia.imagem;
    this.PontoFisico = ocorrencia.pontoFisico;
    this.IdSetorPontoFisico = ocorrencia.idSetorPontoFisico;
    this.IdProcessoSetor = ocorrencia.idProcessoSetor;
    this.IdRotinaProcesso = ocorrencia.idRotinaProcesso;
    this.IdCriterioAvaliacaoRotinaCliente = ocorrencia.idCriterioAvaliacaoRotinaCliente;
    this.DataEncerramento = ocorrencia.dataEncerramento;
    this.ComentariosOcorrencia = ocorrencia.comentariosOcorrencia;
    this.TransicoesOcorrencia = ocorrencia.transicoesOcorrencia;
  }

  copyObject(ocorrencia: Ocorrencia): void {
    this.idOcorrencia = ocorrencia.idOcorrencia;
    this.dataAbertura = ocorrencia.dataAbertura;
    this.dataAberturaString = ocorrencia.dataAberturaString;
    this.tipoOcorrencia = ocorrencia.tipoOcorrencia;
    this.descricaoOcorrencia = ocorrencia.descricaoOcorrencia;
    this.statusOcorrencia = ocorrencia.statusOcorrencia;
    this.prazoSolucao = ocorrencia.prazoSolucao;
    this.idCliente = ocorrencia.idCliente;
    this.idUsuario = ocorrencia.idUsuario;
    this.imagem = ocorrencia.imagem;
    this.pontoFisico = ocorrencia.pontoFisico;
    this.idSetorPontoFisico = ocorrencia.idSetorPontoFisico;
    this.idProcessoSetor = ocorrencia.idProcessoSetor;
    this.idRotinaProcesso = ocorrencia.idRotinaProcesso;
    this.idCriterioAvaliacaoRotinaCliente = ocorrencia.idCriterioAvaliacaoRotinaCliente;
    this.dataEncerramento = ocorrencia.dataEncerramento;
    this.comentariosOcorrencia = ocorrencia.comentariosOcorrencia;
    this.transicoesOcorrencia = ocorrencia.transicoesOcorrencia;
  }

  modeloCompleto(): boolean {
    return this.dataAbertura !== undefined && this.tipoOcorrencia !== undefined
      && this.descricaoOcorrencia !== undefined && this.statusOcorrencia !== undefined && this.prazoSolucao !== undefined
      && this.idCliente !== undefined && this.idUsuario !== undefined;
  }

  getNewInstance(object?: any): Ocorrencia {
    return new Ocorrencia(object);
  }
}



// WEBPACK FOOTER //
// C:/Development/Projects/Sun/Flag/workspace/flagvarejoang4/src/app/comum/modelos/ocorrencia.ts